export const saleDocTypeLabel = (dType) => {
  const t = String(dType || '').trim().toLowerCase();
  if (t === 'order') return 'Замовлення';
  if (t === 'sale') return 'Продаж';
  return '';
};
